import { render, staticRenderFns } from "./organize.vue?vue&type=template&id=bde36f08&scoped=true&"
import script from "./organize.vue?vue&type=script&lang=js&"
export * from "./organize.vue?vue&type=script&lang=js&"
import style0 from "./organize.vue?vue&type=style&index=0&id=bde36f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde36f08",
  null
  
)

export default component.exports